import React from 'react'
import { Table, Modal, Segment, Dimmer, Loader, Button } from 'semantic-ui-react'

import utils from '../utils'

import OrderRow from '../containers/orders/components/OrderListItem'

class OrderDetailModal extends React.PureComponent {
  render() {
    const { visible, onClose, order, loading } = this.props
    const orderNumber = order ? utils.order.getOrderNumber(order) : ''

    return (
      <Modal
        open={visible}
        style={{ marginTop: 0, width: '90vw' }}
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>
          Order Detail {orderNumber.toUpperCase()}
        </Modal.Header>
        <Modal.Content style={{ padding: 0 }}>
          <Segment style={{ padding: 0, boxShadow: 'none', border: '0px', minHeight: 50 }}>
            <Dimmer active={loading} inverted>
              <Loader />
            </Dimmer>
            {
              order &&
              <Table basic style={{ marginTop: 0 }}>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell style={{ width: "12%" }}>Customer</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "15%" }}>Resturant</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "25%" }}>Items</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "13%" }} textAlign="center">Payment</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "10%" }} textAlign="center">Driver</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "10%" }} textAlign="center">Ordered at</Table.HeaderCell>
                    <Table.HeaderCell style={{ width: "15%" }} textAlign="center">Status/Actions</Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  <OrderRow key={order.key} order={order} readOnly />
                </Table.Body>
              </Table>
            }
          </Segment>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={onClose} disabled={loading}>
            Close
            </Button>
        </Modal.Actions>
      </Modal>
    )
  }
}

export default OrderDetailModal


// WEBPACK FOOTER //
// ./src/lib/OrderDetailModal.js